import { CitationStyle } from '../utils/citationFormatter';

/**
 * Citation configuration
 * 
 * TODO: Make this configurable per-space or per-document
 * Store in document Y.js Map or space settings
 */

export interface CitationConfig {
  // Citation style for in-text citations
  style: CitationStyle;
  
  // Bibliography style (can be different from citation style)
  bibliographyStyle?: CitationStyle;
  
  // Include DOIs in bibliography
  includeDOI: boolean;
  
  // Include URLs in bibliography
  includeURL: boolean;
  
  // Maximum authors before "et al."
  maxAuthorsBeforeEtAl: number;
}

export const DEFAULT_CITATION_CONFIG: CitationConfig = {
  style: 'apa', // Use CSL style names directly
  bibliographyStyle: 'apa',
  includeDOI: true,
  includeURL: false,
  maxAuthorsBeforeEtAl: 3
};

/**
 * Get citation configuration for a document
 * 
 * TODO: Fetch from document Y.js Map or space settings
 * For now, returns default configuration
 */
export function getCitationConfig(docId?: string): CitationConfig {
  // TODO: Fetch from Y.js Map:
  // const ydoc = getYDocForDoc(docId);
  // const config = ydoc.getMap('citationConfig').toJSON();
  // return { ...DEFAULT_CITATION_CONFIG, ...config };
  
  return DEFAULT_CITATION_CONFIG;
}

/**
 * Set citation configuration for a document
 * 
 * TODO: Store in document Y.js Map for persistence
 */
export function setCitationConfig(docId: string, config: Partial<CitationConfig>): void {
  // TODO: Store in Y.js Map:
  // const ydoc = getYDocForDoc(docId);
  // const configMap = ydoc.getMap('citationConfig');
  // Object.entries(config).forEach(([key, value]) => {
  //   configMap.set(key, value);
  // });
  
  console.log('[CitationConfig] Config update requested:', config);
  console.log('[CitationConfig] TODO: Implement persistence to Y.js Map');
}

/**
 * Available Citation Styles (via CSL)
 * 
 * Common styles include:
 * - 'apa': APA 7th edition
 * - 'mla': MLA 9th edition  
 * - 'chicago-note-bibliography': Chicago Manual of Style
 * - 'harvard1': Harvard referencing
 * - 'vancouver': Vancouver (medical)
 * - 'ieee': IEEE
 * - 'nature': Nature journal
 * - 'science': Science journal
 * - 'cell': Cell journal
 * - 'ama': American Medical Association
 * 
 * See cslFormatter.getAvailableStyles() for full list.
 * Custom CSL styles can be loaded via loadCustomCSLStyle().
 */

/**
 * ROADMAP: Enhanced Citation Features
 * 
 * ✅ 1. citation-js integration (DONE)
 * ✅ 2. CSL-based formatting (DONE)
 * ⬜ 3. Support CSL style files (.csl) from Zotero Style Repository
 * ⬜ 4. Allow users to upload custom .csl files
 * ⬜ 5. Support citation editing (add page numbers, prefixes/suffixes)
 * ⬜ 6. Import/export to BibTeX, RIS, CSL-JSON
 * ⬜ 7. Integration with Zotero/Mendeley for syncing
 * ⬜ 8. Per-document citation style configuration
 * 
 * Resources:
 * - citation-js: https://citation.js.org/
 * - CSL Styles: https://github.com/citation-style-language/styles
 * - CSL Spec: https://docs.citationstyles.org/
 */

